import React from 'react';
import { Field as FormikField, Form as FormikForm, Formik } from 'formik';
import { useIntl } from 'react-intl';
import { object as YupObject, string as YupString } from 'yup';

import { emailValidationRegex } from 'app/shared/utils/emailValidation';
import { Box } from 'app/shared/components/atoms';
import {
  ModalButtonsSection,
  Textfield,
} from 'app/shared/components/molecules';

interface Props {
  onSubmit: any;
}

export const Form: React.FC<React.PropsWithChildren<Props>> = ({
  onSubmit,
}) => {
  const { formatMessage } = useIntl();

  const validationSchema = YupObject().shape({
    email: YupString()
      .matches(emailValidationRegex, {
        message: formatMessage(
          {
            id: 'form.fieldMustBeValidEmail',
          },
          {
            field: 'Email',
          }
        ),
      })
      .required(formatMessage({ id: 'newsletter.form.emailRequired' })),
  });

  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <FormikForm
          onSubmit={handleSubmit}
          data-qaid="event-collection-follow-form"
        >
          <Box gap={4} flexDirection="column">
            <FormikField
              as={Textfield}
              name="email"
              hasError={touched.email && !!errors.email}
              helperText={touched.email ? errors.email : undefined}
              label={formatMessage({ id: 'form.fields.email' })}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              type="email"
              autoCapitalize="off"
              autoComplete="one-time-code"
              data-qaid="event-collection-follow-form-email"
            />
            <ModalButtonsSection
              primaryCtaText={formatMessage({ id: 'shared.signUp' })}
              primaryCtaType="submit"
              isPrimaryCtaLoading={isSubmitting}
            />
          </Box>
        </FormikForm>
      )}
    </Formik>
  );
};
